import { SOLAR } from "@/constants/testIds";
import { dayLengthHours, formatDuration, formatTimeShort, type SolarResult } from "@/lib/solar";
import { SunEvent } from "@/components/solar/ui";

interface SunEventsProps {
  result: SolarResult;
  placeTz: string;
  now: Date;
  lat: number;
}

function dayLengthText({ result, now, lat }: SunEventsProps): string {
  if (result.dayLengthMinutes != null) return formatDuration(result.dayLengthMinutes);
  return dayLengthHours(now, lat) >= 12 ? "Midnight sun" : "Polar night";
}

const Divider = () => <div className="hidden h-px flex-1 bg-[#d9c9ad] md:block" />;

export default function SunEvents(props: SunEventsProps) {
  const { result, placeTz } = props;
  const time = (d: Date | null) => (d ? formatTimeShort(d, placeTz) : "—");
  // Same instant read on the sundial: clock time shifted by EoT + longitude correction.
  const solar = (d: Date | null) =>
    d ? `${formatTimeShort(new Date(d.getTime() + result.offsetMinutes * 60_000), placeTz)} true solar time` : undefined;
  return (
    <section className="mb-16 flex flex-col gap-10 border-t border-[#d9c9ad] pt-10 md:flex-row md:items-center md:justify-between">
      <SunEvent label="Sunrise" testid={SOLAR.sunrise} value={time(result.sunrise)} sub={solar(result.sunrise)} subTestid={SOLAR.sunriseSolar} />
      <Divider />
      <SunEvent label="Day length" testid={SOLAR.dayLength} value={dayLengthText(props)} align="center" sub={result.dayLengthMinutes != null ? "same on both clocks" : undefined} />
      <Divider />
      <SunEvent label="Sunset" testid={SOLAR.sunset} value={time(result.sunset)} sub={solar(result.sunset)} subTestid={SOLAR.sunsetSolar} align="right" />
    </section>
  );
}
